export type MaxWidth = "fit" | "full";

export type MaxWidthMap = {
  [key in MaxWidth]: string;
};

export const maxWidthClassMap = {
  fit: "max-w-fit",
  full: "max-w-full",
} as const;
